import { isSecureURL } from '@grouper/modules/core/utils/string'
import { getCookieName } from '@grouper/modules/core/utils/cookie'
import { useCookie } from '#app'

// NOTE: this has been deliberately left as `group`. A future task will rename it.
const cookieWorkspaceName = 'grouper_group_id'

export const setWorkspaceCookie = (workspaceId, appOrContext) => {
  return appOrContext.runWithContext(() => {
    const { $config } = appOrContext
    const secure = isSecureURL($config.public.publicWebFrontendUrl)
    const cookie = useCookie(getCookieName($config, cookieWorkspaceName), {
      path: '/',
      maxAge: 60 * 60 * 24 * 7,
      sameSite: $config.public.grouperFrontendSameSiteCookie,
      secure,
    })
    cookie.value = workspaceId
  })
}

export const unsetWorkspaceCookie = (appOrContext) => {
  return appOrContext.runWithContext(() => {
    const { $config } = appOrContext
    const cookie = useCookie(getCookieName($config, cookieWorkspaceName))
    cookie.value = null
  })
}

export const getWorkspaceCookie = (appOrContext) => {
  return appOrContext.runWithContext(() => {
    const { $config } = appOrContext
    return useCookie(getCookieName($config, cookieWorkspaceName)).value
  })
}
